import Button from '../../components/Button.jsx';
import Icon from '../../components/Icon.jsx';
import styles from './TodayCard.module.scss';

const SECONDS_PER_CARD = 8;

/** The "what should I do now?" card: one number, one plain sentence, one button. */
export function TodayCard({ counts, to, title, extra }) {
  const due = counts.new + counts.learn + counts.review;
  const minutes = Math.max(1, Math.round((due * SECONDS_PER_CARD) / 60));
  const parts = [];
  if (counts.review) parts.push(`${counts.review} to review`);
  if (counts.learn) parts.push(`${counts.learn} in progress`);
  if (counts.new) parts.push(`${counts.new} new`);

  if (!due) {
    return (
      <section className={`${styles.card} ${styles.done}`} aria-label={title}>
        <span className={styles.doneIcon}>
          <Icon name="check" size={26} stroke={3} />
        </span>
        <div className={styles.text}>
          <h2>You’re all caught up</h2>
          <p>Nothing is due right now. New cards and reviews show up here when it’s time.</p>
        </div>
        {extra}
      </section>
    );
  }

  return (
    <section className={styles.card} aria-label={title}>
      <div className={styles.top}>
        <div>
          <p className={styles.eyebrow}>{title}</p>
          <p className={styles.big}>
            {due}
            <span>{due === 1 ? 'card' : 'cards'}</span>
          </p>
        </div>
        <p className={styles.time}>
          <Icon name="calendar" size={16} />
          About {minutes} min
        </p>
      </div>
      <p className={styles.split}>{parts.join(' · ')}</p>
      <div className={styles.actions}>
        <Button variant="primary" size="lg" icon="play" to={to} block>
          Start studying
        </Button>
        {extra}
      </div>
    </section>
  );
}
